import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import * as S from '../Loyaly.styles';
import {
  getLoyaltyFaqAndTncData,
  getLoyaltyDashboardData,
  getLoyaltyPageTemplate,
} from '../../store/actions/thunk';
import {logPageLoadEvents} from '@ibibo/analytics';
import useWindowSize from '../../../../../hooks/use-window-size/src/use-window-size';
import {getter} from 'client-side-storage/src/client-side-storage.web';
import {LOGIN_URL_NEW} from '../../constants';

import DashboardV2 from './components/Dashboard-v2/Dashboard-v2';
import HeroSuperPower from './components/HeroSuperPower/HeroSuperPower';
import Faqs from './components/Faqs/Faqs';
import Footer from './components/Footer/Footer';
import HeaderContainer from './components/HeaderContainer/HeaderContainer';
import IntroducingMypartner from './components/IntroducingMypartner/IntroducingMypartner';
import MyPartnerHeroBanner from './components/MyPartnerHeroBanner/MyPartnerHeroBanner';
import HeroPlus from './components/HeroPlus/HeroPlus';
const Landing = () => {
  const dispatch = useDispatch();
  const winSize = useWindowSize();

  const [data, setData] = useState(null);
  const {body} = data || {};
  const [viewDetailsModal, setViewDetailsModal] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [faqData, setFaqData] = useState([]);
  const [tncData, setTncData] = useState([]);
  const [responseData, setResponseData] = useState(null);
  const [hotelTravelCompletedAmount, setHotelTravelCompletedAmount] = useState(0);
  const [hotelYetToTravelAmount, setHotelYetToTravelAmount] = useState(0);

  // Log page load events
  useEffect(() => {
    logPageLoadEvents('myPartner_loyaltyHero|landingPage', {
      eVar15: 'myPartner_loyaltyHero|landingPage',
    });
  }, []);

  // Fetch FAQ, TnC, and dashboard data on initial load
  useEffect(() => {
    const month = new Date().getMonth() + 1;
    dispatch(getLoyaltyDashboardData(month, true, successCallbackDashboard, errorCallback));
    dispatch(getLoyaltyFaqAndTncData(faqLoyaltyTnCSuccessCallback, errorCallback));
  }, [dispatch]);

  const successCallbackDashboard = data => {
    if (data?.error?.redirectUrl) {
      window.location.href = data.error.redirectUrl;
      return;
    }

    if (data?.additionalData) {
      setData(data?.additionalData);
    } else {
      dispatch(getLoyaltyPageTemplate(loyaltyTemplateSuccessCallback, errorCallback));
    }
    setHotelTravelCompletedAmount(data?.hotelTravelCompletedAmount || 0);
    setHotelYetToTravelAmount(data?.hotelYetToTravelAmount || 0);
    setResponseData(data);
  };

  const errorCallback = error => {};

  const loyaltyTemplateSuccessCallback = data => {
    setData(data);
  };

  const faqLoyaltyTnCSuccessCallback = data => {
    setFaqData(data?.faq_data);
    setTncData(data?.tnc_data);
  };

  // Handle sticky header based on scroll position
  const handleScroll = () => {
    if (winSize.width > 768) {
      setIsSticky(window.scrollY >= 100);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [winSize]);

  // Handle booking action based on login status
  const onStartBooking = () => {
    const mmtAuthObject = getter('myPartnerAuth');
    const isLoggedIn = mmtAuthObject?.mmt_auth;
    const bookingUrl = isLoggedIn
      ? 'https://www.makemytrip.com/?action=smartbuy&open=browser'
      : LOGIN_URL_NEW;
    window.open(bookingUrl, '_self');
  };

  if (typeof window === 'undefined') {
    return null;
  }

  return (
    <S.LoyaltyPage>
      <HeaderContainer isSticky={isSticky} header={data?.header} />
      <div className="container">
        <MyPartnerHeroBanner
          heading="How to Become A <span>myPartner HERO?</span>"
          subHeading="Enjoy hero superpowers the next month by getting your customers to complete travel worth <span>₹ 7 lacs this month.</span>"
          cta="Start Booking"
          bannerImage={body?.howToBecomeHero?.bannerUrl}
          onStartBooking={onStartBooking}
        />
        <DashboardV2
          responseData={responseData}
          hotelTravelCompletedAmount={hotelTravelCompletedAmount}
          hotelYetToTravelAmount={hotelYetToTravelAmount}
          setResponseData={setResponseData}
          handleViewDetails={() => setViewDetailsModal(!viewDetailsModal)}
          noDetails={false}
          graphTemplateData={body?.dashboard}
        />
        <HeroPlus data={body?.heroSuperStar} />
        <HeroSuperPower data={body?.heroBenifits} />
      </div>
      <IntroducingMypartner onStartBooking={onStartBooking} />
      <div className="container">
        <Faqs
          heading="Frequently Asked Questions"
          faqData={faqData}
          tncHeading="Terms and Conditions"
          tncData={tncData}
        />
      </div>
      <Footer />
    </S.LoyaltyPage>
  );
};

export default Landing;
